export class DeleteConfirmationParam{
    public dialogTitle: string;
    public dialogMessage: string;
    public deleteServiceUrl:string;
}